import ptLocale from 'element-ui/lib/locale/lang/pt'
const pt = { //Portuguese
login:{
buttoo:{
    add:'新增'
}
},
dialog:{
buttton:{
    close:'关闭'
},
ReportError:{
    next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},
Home:{
    Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'Selecione o país',
 inputCompany:'Introduza o nome da empresa',
 keWord:'Palavra-chave',
 firstWord:"Texto (palavras da esquerda)",
 searchCompanyNum:"Search 500+ million companies in 200+ countries and territories",
 search:'Buscar',
 homeSeachTitle:'Trazendo o foco para os negócios globais',
 homeTitleDetail:'A CSI, uma empresa de pesquisa e TI orientada por dados, é especializada em crédito, risco e big data. Ela oferece ferramentas digitais para investidores e profissionais de negócios globais, utilizando análises e algoritmos avançados para fornecer insights rápidos e visuais que facilitam a tomada de decisões mais inteligentes.',
 phoneTitleDetail:'Para pesquisar, visualizar e obter informações da empresa rapidamente, você também pode usar o aplicativo CSI no seu celular.',
  IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 
},
IndustryStatistics:{
    SubjectCompany:"Empresa em Assunto",
    Country:"País",
    Compare:"Comparar",
    Industry:"Setor",
    CompanyType:"Tipo de Empresa",
    CompanySize:"Tamanho da Empresa",
    CompanyStatus:"Status da Empresa",
    YearsinBusiness:"Anos de Atividade",
    CompanyRating:"Classificação da Empresa"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page',


},
Toolbar:{
    Filter:"Filtrar",
    Select:"Selecionar",
    Edit:"Editar",
    Sortby:"Classificar por",
    Collect:"Coletar",
    Saved:"Salvos",
    Compare:"Comparar",
    Export:"Exportar",
    Download:"Baixar",
    Update:"Atualizar",
    Reporterror:"Relatar erro",
    Share:"Compartilhar",
    ascending:'ascending',
    descending:'descending',
    Customfolder:'Custom folder'
},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
navigationBar:{
Notifications:'Notificações',//通知
MarkasRead:'Marcar como Lido',//标记已读
Viewall:'Ver tudo',//查看全部
SilverSubscriber:'Assinante Silver',//银级用户
Silversubscriberdate:'Data de validade da assinatura Silver',//银级到期日
GoldSubscriber:'Assinante Gold',//金级用户
Goldsubscriptiondate:'Data de validade da assinatura Gold',//金级到期日
AvailableCredits:'Créditos Disponíveis',//可用积分
AddCredits:'Adicionar Créditos',//购买积分
IndivdualAccount:'Conta Individual', //个人账号
GroupAccount:'Conta de Grupo' //集团账号

},
Snapshot:{
    CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:'DQI da Empresa',//公司数据质量指数 DQI
  CountryDQI:'DQI do País',//国家数据质量指数 DQI
  Address:'Endereço',//地址
  CountyCity:'Condado/Cidade',//县/市
  ProvinceState:'Província/Estado',//省/州
  CountryRegion:'País/Região',//国家/地区
  ZipCode:'CEP',//邮政编码
  Website:'Website',//网站
  Email:'E-mail',//电邮
  Tel:'Tel',//电话
  LastUpdate:'Última Atualização',//最近更新
  DataSource:'Fonte de Dados',//数据来源
  LegalStatus:'Situação Legal',//法定状况
  CoID:'ID da Empresa',//公司ID
  CompanyType:'Tipo de Empresa',//公司类型
  RegistrationDate:'Data de Registro',//注册日期
  RegistrationStatus:'Status de Registro',//注册状态
  Listed:'Listada',//上市信息
  CurrentOpperations:'Operações Atuais',//经营状况
  IndustryCode:'Código do Setor',//行业代码
  BusinessActivities:'Atividades Comerciais',//主营业务
  NoofEmployees:'Nº de Funcionários',//员工数量
  NoofShareholders:'Nº de Acionistas',//股东数量
  Management:'Gestão',//管理状况
  Performance:'Desempenho',//业绩表现
  Revenue:'Receita',//收入
  Assets:'Ativos',//资产
  ProfitLoss:'Lucro/Prejuízo',//利润
  Growth:'Crescimento',//公司增长
  Competitiveness:'Competitividade',//竞争力
  CreditOpinion:'Opinião de Crédito',//信用状况
  CreditRating:'Classificação de Crédito',//信用评级
  CreditScore:'Score de Crédito',//信用评分
  ESGRating:'Classificação ESG',//ESG 评级
  Solvency:'Solvência',//偿还能力
  Sanctions:'Sanções',//全球制裁
},
Profile:{
  CompanyProfile:'Perfil da Empresa',//基本资料
  CompanyName:'Nome Próprio',//公司名称
  NativeName:'Nome Próprio',//当地名称
  CompanyID:'ID da Empresa',//公司 ID
  VATNumber:'Número de IVA',//VAT号
  StockCode:'Código da Ação',//股票代码
  Listed:'Listada',//上市日期
  RegistrationDate:'Data de Registro',//注册日期
  LegalForm:'Forma Legal',//公司性质
  CompanyType:'Tipo de Empresa',//公司类型
  LegalStatus:'Situação Legal',//注册状态
  Jurisdiction:'Jurisdição',//司法管辖区
  RegisteredAddress:'Endereço Registrado',//注册地址
  ProvinceState:'Província/Estado',//省/州
  CountryRegion:'País/Região',//国家/地区
  ZipCode:'CEP',//邮政编码
  OperatingAddress:'Endereço Operacional',//经营地址
  LastUpdate:'Última Atualização',//最近更新
  DataSource:'Fonte de Dados',//数据来源
  History:'Histórico',//历史记录
    RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
       CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'Beneficiário Final',//最终受益人
  InvolvingIndividuals:'Envolvendo Pessoas Físicas',//涉及自然人股东
  InvolvingEnterprises:'Envolvendo Empresas',//涉及法人股东
  ShareholderLevel:'Nível de Acionista',//股东层级x
  Name:'Nome',//名称
  Country:'País',//国家/地区
  Location:'Localização',//地点
  Type:'Tipo',//类型
  Shares:'Ações',//股份
  Relation:'Relação',//关系
    Individuals :'Individuals',//关系
        PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Total',//相关公司总计
  Entities:'Entidades',//法人实体
  Countries:'Países',//国家/地区
  Branches:'Filiais',//分支机构
  RelatedComp:'Empresas Relacionadas',//关联公司
  Name:'Nome',//名称
  Country:'País',//国家/地区
  Location:'Localização',//地点
  Type:'Tipo',//类型
  Relation:'Relacionamento',//关系
    BranchOffices:'支店',
  Individuals:'個人',
},
Management:{
  Total:'administração',//管理层
  ContactInfo:'Informações de contato',//联系人信息
  Countries:'Países',//国家/地区

  Name:'Nome',//名称
  Position:'Cargo',//职位
  Department:'Departamento',//部门
  Country:'País',//国家/地区
  ShareholderNot:'Acionista ou não',//是否股东
  Relation:'Relacionamentos',//关系
  Verification:'Verificação',//已验证
  Searchmoreemails:'Pesquisar mais e-mails',//搜索更多电邮
  Roles:'Funções',//角色
  EducationLevel:'Nível de escolaridade',//教育程度
  Phone:'Telefone',//电话
  Email:'E-mail',//电邮
  Verified:'Verificado',//已验证
  Searchmore:'Pesquisar mais e-mails de outras empresas',//搜索更多其他公司的电邮
},
Operations:{
    Operations:'Operations',
  LineofBusiness:'Ramo de Atividade',//业务范围
  BusinessTerritories:'Territórios Comerciais',//业务区域
  ImportExport:'Importação e Exportação',//进出口信息
  Viewtradeinfo:'Ver mais informações comerciais',//查看更多贸易信息
  ProductsServices:'Produtos/Serviços',//产品/服务
  Products:'Produtos',//产品
  ProductImage:'Imagem do Produto',//产品图片
  ProductName:'Nome do Produto',//产品名称
  ProductDescription:'Descrição do Produto',//产品描述
  Details:'Detalhes',//详情
  Addproductinformation :'Adicionar informações do produto',//添加产品信息
},
Locations:{
   Locations:"Locations",
  CoName:'Nome da Empresa',//业务范围
  Relationship:'Relacionamento',//关系
  Country:'País',//国家/地区
  Location:'Localização',//地点
  Address:'Endereço',//地址
  Edit:'Editar',//编辑
  CompanyLocatiionsMap:'Localizações da Empresa no Mapa',//地图中的公司位置
  Selectaddresstype:'Empresa em questão',//选择地址类型
  Subjectcompany:'Empresa em questão',//目标公司
  Subsidiary:'Subsidiária',//子公司
  RegisteredAddress :'Endereço Registrado',//注册地址
  OperationAddress :'Endereço Operacional',//运营地址
  All :'Todos',//全部
},
ContentTabs:{
    Background:"Histórico",
    BusinessActivities:"Atividades Comerciais",
    Performance:"Desempenho",
    Publications:"Publicações",
    CreditOpinion:"Opinião de Crédito",
    MarketAnalysis:"Análise de Mercado",
    Snapshot:"Instantâneo",
    Profile:"Perfil",
    Ownership:"Propriedade",
    RelatedCompanies:"Empresas Relacionadas",
    Management:"Gestão",
    Operations:"Operações",
    Locations:"Localizações",
    Industry:"Setor",
    ImportExport:"Importação e Exportação",
    SupplyChain:"Cadeia de Suprimentos",
    FinancialHighlights:"Destaques Financeiros",
    RatioAnalysis:"Análise de Índices",
    IndustryNorm:"Norma do Setor",
    News:"Notícias",
    Sanctions:"Sanções",
    IndustryStatistics:"Estatísticas do Setor",
    RatingAnalysis:"Análise de Rating",
    CompetitiveAnalysis:"Análise Competitiva"
},
ImportExport:{
  TotalImportAmount:'Valor Total de Importação',//进口总额
  TopImportCountry:'Principal País Importador',//最大进口国家/地区
  TopImportProduct:'Principal Produto Importador',//最大进口产品
  TotalExport:'Total de Exportação',//出口总额
  TopExportCountry:'Principal País Exportador',//最大出口国家/地区
  TopExportProduct:'Principal Produto Exportador',//最大出口产品
  TradeVolume:'Volume de Comércio',//贸易额
  ImportShipments:'Remessas de Importação',//进口量
  ExportShipments:'Remessas de Exportação',//出口量
  ImportCountries:'Países Importadores',//进口国家/地区
  ExportCountries:'Países Importadores',//出口国家/地区
  ImportVolume:'Volume de Importação',//进口量
  ExportVolume:'Volume de Exportação',//出口量
  TopSuppliers:'Principais Fornecedores',//主要供应商
  ByNumberofShipments:'Por Número de Remessas',//按出货量
  TopBuyers:'Principais Compradores',//主要买家
  ByNumberofShipments:'Por Número de Remessas',//按出货量
  ImportQuantity:'Quantidade Importada',//进口数量
  IncreaseDecreasexRate:'Taxa de Aumento/Diminuição',//增/减率
  ExportQuantity:'Quantidade Exportada',//出口数量
  ImportsExportsRecords:'Registros de Importação e Exportação',//进出口记录
  Date:'Data',//日期
  Product:'Produto',//产品
  HSCode:'Código SH',//HS 编码
  BuyerName:'Nome do Comprador',//买家名称
  Destination:'Destino',//目的地
  SupplierName:'Nome do Fornecedor',//供应商名称
  Origin:'Origem',//原产地
  Amount:'Valor',//金额
  Details:'Detalhes',//详情
},
 FinancialHighlight:{
      ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:'Receita',//收入
  Profit:'Lucro',//利润
  Growth:'Crescimento',//增长
  Liquidity:'Situação do Fluxo de Caixa',//现金流状况
  FinancialStructure:'Estrutura Financeira',//融资结构
  CreditOpinion:'Opinião de Crédito',//信用评估
  RiskIndicator :'Indicador de Risco',//风险指标
  Solvencyindex:'Índice de Solvência',//偿还指数
  Year:'Ano',//年份
  Change:'Variação',//变化
  FinancialHighlights:'Dados Financeiros das Empresas Relacionadas',//关联公司财务数据
  FinancialHighlightsTitle:'Destaques Financeiros das Empresas Relacionadas',//关联公司财务摘要
  CompanyName:'Nome da Empresa',//公司名称
  CompanyID:'ID da Empresa',//公司ID
  Country:'País',//国家/地区
  CompanyStatus:'Situação da Empresa',//公司状态
  Relations:'Relacionamentos',//关系
  RatioAnalysis:'Análise dos Índices das Empresas Relacionadas'
},
RatingAnalysis:{
    IndustyAnalysis:"Análise do Setor",
    GeographicAnalysis:"Análise Geográfica",
    CompanyTypeAnalysis:"Análise do Tipo de Empresa",
    BiusinessScaleAnalysis:"Análise da Escala de Negócios",
    HistoryAnalysis:"Análise Histórica",
    NormalDistribution:"Distribuição Normal",
    SubjectCompany:"Empresa em Questão",
    Probabilityofthesubjectratinginitsindustry:"Probabilidade da classificação da empresa em questão em seu setor",
    Maximum:"Máximo 10%",
    Mean:"Média",
    Average:"Média",
    Minimum:"Mínimo 10%",
    RatingDistribution:"Distribuição da Classificação",
    Revenue:"Receita",
    Earning:"Lucro",
    TotalAssets:"Ativo Total",
    Subjectratinginitsindustrybyfinancialindicators:"Classificação da empresa em seu setor por indicadores financeiros",
    Best:"Melhor",
    Worst:"Pior",
    Rankingofsubject:"Classificação da classificação da empresa no setor",
    Industy:"Setor",
    Percentilerank:"Classificação percentual: % de empresas com pontuação igual ou inferior à classificação da empresa",
    Historicaldevelopmentofsubject:"Desenvolvimento histórico da classificação da empresa em seu setor",
    IndustryAverage:"Média do Setor",
    SubjectRatingChanges:"Mudanças na Classificação da Empresa"
},
CompetitiveAnalysis:{
    MarketPosition:"Posição de Mercado",
    Revenus:"Receita",
    NetEarnings:"Lucro Líquido",
    NetAssets:"Ativo Líquido",
    TotalAssets:"Ativo Total",
    Employees:"Funcionários",
    Mean:"Média",
    Average:"Média",
    Maximum:"Máxima (10%)",
    Worst:"Pior (10%)",
    Subjectcompany:"Empresa em questão",
    PerformanceComparison:"Comparação de Desempenho",
    ProfitabilityRatios:"Índices de Rentabilidade",
    Grossmargin:"Margem Bruta",
    Returnonassets:"Retorno sobre o Ativo",
    Returnonequity:"Retorno sobre o Patrimônio Líquido",
    Average:"Média",
    OperatingRatios:"Índices Operacionais",
    Stockturnover:"Giro de Estoque",
    Assetsturnover:"Giro de Ativo",
    Collectionperiod:"Período de Cobrança",
    GrowthRatios:"Índices de Crescimento",
    Totalassetsgrowthrate:"Taxa de Crescimento do Ativo Total",
    Salesgrowthrate:"Taxa de Crescimento das Vendas",
    Netprofitgrowthrate:"Taxa de Crescimento do Lucro Líquido",
    StructuralRatios:"Índices de Estrutura",
    Debtratio:"Índice de Endividamento",
    Quickratio:"racio rápido",
    Currentratio:"Índice de Liquidez Corrente"
},
IndustryNorms:{
    IndustryStatistics:"Estatísticas do Setor",
    ofcompaniesintheIndustry:"Nº de empresas no Setor",
    oflistedCompaniesintheIndustry:"Nº de empresas listadas no Setor",
    oflargecompaniesintheIndustry:"Nº de grandes empresas no Setor",
    ofSMEsintheIndustry:"Nº de PMEs no Setor",
    ofcompaniesinsample:"Nº de empresas na amostra",
    ofcompaniesinloss:"Nº de empresas com prejuízo",
    Observations:"Observações",
    AverageValue:"Valor Médio",
    MedianValue:"Valor Mediano",
    MaximumValue10:"Valor Máximo 10%",
    MinimumValue10:"Valor Mínimo 10%",
    SubjectCompany:"Empresa em Estudo",
    YearsinBusiness:"Anos de Atividade",
    TotalAssets:"Total de Ativos",
    TotalEquity:"Patrimônio Líquido Total",
    Revenue:"Receita",
    NetEarning:"Lucro Líquido",
    Returnonassets:"Retorno sobre Ativos",
    Performance:"Desempenho",
    ProfitabilityRatios:"Índices de Rentabilidade",
    Returnonequity:"Retorno sobre Patrimônio Líquido",
    Returnonassets:"Retorno sobre Ativos",
    Grossmargin:"Margem Bruta",
    OperatingRatios:"Índices Operacionais",
    Stockturnover:"Giro de Ações",
    Accountsreceivableturnover:"Giro de Contas a Receber",
    Assetsturnover:"Giro de Ativos",
    Totalassetturnover:"Giro de Ativos Total",
    StructuralRatios:"Índices de Estrutura",
    Currentratio:"Índice de Liquidez Corrente",
    Quickratio:"racio rápido",
    Shareholdersliquidityratio:"Índice de Liquidez Acionária",
    GrowthRatios:"Taxas de Crescimento",
    Salesgrowthrate:"Taxa de crescimento das vendas",
    Netprofitgrowthrate:"Taxa de crescimento do lucro líquido",
    Totalassetsgrowthrate:"Taxa de crescimento do ativo total"
},
 News:{
  Date:'Data',//日期
  Title:'Título',//标题
  Source:'Fonte',//来源
  Impact:'Impacto',//影响
  Searchcompanies:'Pesquise mais notícias sobre outras empresas',//国家/地区
},
Sanctions:{
  Potentialcompliance:'Possíveis riscos de conformidade detectados',//检测到潜在合规风险
  SeachbuttonNo:'Nada prejudicial detectado nesta empresa',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'Para pesquisar mais registros de sanções, clique no botão "Pesquisar Sanções".',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Pesquisar Sanções',//搜索制裁
  ViewDetails:'Ver Detalhes',//查看详情
  Sanctions:'Sanções',//制裁
  Potentialcompliancerisks:'Possíveis riscos de conformidade',//潜在合规风险
  IDInfo:'Informações do ID',//ID 信息
  IDType:'Tipo de ID',//ID 类型
  IDDescription:'Descrição do ID',//ID 描述
  SanctionList:'Lista de Sanções',//制裁名单
  SanctionListInvolved:'Lista de Sanções Envolvidas',//涉及的制裁名单
  StartDate:'Data de Início',//生效日期
  EndDate:'Data de Término',//结束日期
  SourceList:'Lista de Fontes',//来源名单
  SourceName:'Nome da Fonte',//来源名称
  ProfileNotes:'Observações do Perfil',//主体资料
  Link:'Link',//链接
},
CreditOpinion:{
    CreditAssessment:"Avaliação de Crédito",
    CreditAssessmentfromtheRelatedCompanies:"Avaliação de Crédito das Empresas Relacionadas",
    Year:"Ano",
    CreditRating:"Classificação de Crédito",
    LocalCreditScore:"Pontuação de Crédito Local",
    ProbabilityofDefault:"Probabilidade de Inadimplência",
    SolvencyIndex:"Índice de Solvência",
    CreditLine:"Linha de Crédito",
    RiskIndicator:"Indicador de Risco",
    RelatedCreditAssessment:"Avaliação de Crédito Relacionada",
    CompanyName:"Nome da Empresa",
    CompanyID:"ID da Empresa",
    Country:"País",
    CompanyStatus:"Status da Empresa",
    Relations:"Relacionamentos"
},
AccountCenterMenu:{
SearchinSettings:"Pesquisar em Configurações",//在“设置”中搜索
Account:"Conta",//账户
MyAccount :"Minha Conta",//我的账户
ContactInfo:"Informações de Contato",//联系信息
AccountSecurity:"Segurança da Conta",//账户安全
OrganizationalManagement:"Gerenciamento Organizacional",//组织管理
UserGroup:"Grupo de Usuários",//用户组
User:"Usuário",//用户
Role:"Função",//角色
MyDatabase:"Meu Banco de Dados",//我的数据库
MyUsage:"Meu Uso",//我的使用情况
CompaniesViewed:"Empresas Visualizadas",//查看过的公司
ReportsDownloaded:"Relatórios Baixados",//下载的报告
ReportUpdatesOrdered:"Atualizações de Relatórios Solicitadas",//订购的报告更新
BillingandPayment:"Faturamento e Pagamento",//账单和付款
BillRecords:"Registros de Faturas",//账单记录
PaymentRecords:"Registros de Pagamento",//付款记录
CreditDeductions:"Deduções de Crédito",//信用扣款
InvoicesDownloaded:"Faturas Baixadas",//下载的发票
UserSettings:"Configurações do Usuário",//用户设置
Messages:"Mensagens",//消息
Notifications:"Notificações",//通知
HelpCenter:"Central de Ajuda",//帮助中心
FAQ:"Perguntas Frequentes",//常见问题
Privacy:"Privacidade",//隐私
Terms:"Termos",//条款
ReportIssues:"Problemas com Relatórios",//报告问题
UserGuide:"Guia do Usuário",//用户指南
AboutCSI:"Sobre o CSI"//关于CSI


},
MyAccount:{
Logintime:'Horário de login',//登录时间
SignOut:'Sair',//退出
DeleteAccount:'Excluir conta',//删除账户
AccountID:'ID da conta',//账户ID
Enteranewaddress:'Digite um novo endereço de e-mail',//输入新的电邮
EnterVerificationCode:'Digite o código de verificação',//输入验证码
SendverificationCode:'Enviar código de verificação',//发送验证码
Password:'Senha',//密码
Originalpassword:'Senha original',//原始密码
Newpassword:'Nova senha',//新密码
Confirmnewpassword:'Confirme a nova senha',//确认新密码
AccountOwnership:'Propriedade da conta',//账户所有权
IndividualAccount:'Conta individual',//个人账户
GroupAccount:'Conta de grupo',//集团账户
Organizationname:'Nome da organização',//机构名称
CountryRegion:'País/região',//国家/地区
Address:'Endereço',//地址
City:'Cidade',//城市
ZipCode:'CEP',//邮政编码
FirstName:'Nome',//名字
LastName:'Sobrenome',//姓氏
PhoneNumber:'Número de telefone',//电话号码
Email:'E-mail',//更改
Change:'Alterar',//更改
Save:'Salvar',//保存
Cancel:'Cancelar',//取消
LastLogin:'Último login',//Last Login
RecentLogin:'Login recente',//登录尝试次数
AverageLoginTime:'Tempo médio de login',//平均登录时间
TotalLoginAttempts:'Total de tentativas de login',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"Data",
    MasterBillofLading:"Conhecimento Mestre de Embarque",
    Source:"Origem",
    BillNo:"Número do Conhecimento",
    ImporterBuyer:"Importador / Comprador",
    ExporterSeller:"Exportador / Vendedor",
    Name:"Nome",
    Address:"Endereço",
    Country:"País",
    Contact:"Contato",
    Email:"E-mail",
    CargoInfo:"Informações da Carga",
    HSCode:"Código SH",
    Quantity:"Quantidade",
    WeightUnit:"Unidade de Peso",
    ProductDescription:"Descrição do Produto",
    Amount:"Valor",
    QuantityUnit:"Unidade de Quantidade",
    Weight:"Peso",
    HSDescription:"Descrição SH",
    Incoterms:"Incoterms",
    ShippingInfo:"Informações de Embarque",
    Vessel:"Embarcação",
    Consignee:"Destinatário",
    MeansofTransport:"Meio de Transporte",
    CountryofOrigin:"País de Origem",
    Voyage:"Viagem",
    Notifier:"Notificador",
    CountryofDestnation:"País de Destino",
    AddressofOrigin:"Endereço de Origem",
    Shipper:"Remetente",
    AddressofDestnation:"Endereço de Destino",
    Container:"Contêiner",
    ContainerID:"ID do Contêiner",
    ContainerType:"Tipo de Contêiner",
    ContainerDescDode:"Código de Descrição do Contêiner",
    ContainerSize:"Tamanho do Contêiner"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"Que tipo de erro você está relatando?",
    Tellusmoreaboutyourproblems:"Conte-nos mais sobre seus problemas.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Gostaria de enviar uma captura de tela ou um arquivo relacionado ao seu problema?",
    Fillinyourcontactinformation:"Preencha suas informações de contato",
    FirstName:"Nome",
    LastName:"Sobrenome",
    PhoneNumber:"Número de telefone",
    Email:"E-mail"
},
UserSettings:{
    LanguageandLocation:"Idioma e Localização",
    Language:"Idioma",
    Selectyourpreferedlanguage:"Selecione seu idioma preferido",
    Location:"Localização",
    Selectyourlocation:"Selecione sua localização",
    NotificationSetting:"Configuração de Notificação",
    EmailNotification:"Notificação por E-mail",
    ServiceUpdates:"Atualizações de Serviço",
    CompanyNews:"Notícias da Empresa"
},
ContactInfo:{
    ContactInfo:"Informações de contato",
    FirstName:"Nome",
    LastName:"Sobrenome",
    PhoneNumber:"Número de telefone",
    Email:"E-mail",
    CountryRegion:"País/Região",
    AddressLine:"Endereço",
    City:"Cidade",
    ZipCode:"CEP",
    Alternativecontactperson:"Contato alternativo",
    Setascontactperson:"Definir como contato",
    Edit:"Editar"
},
AccountSecurity:{
    Setupmysecurityquestions:"Configurar minhas perguntas de segurança",
    Pleasechooseaquestion:"Escolha uma pergunta",
    Pleaseentertheanswertothequestion:"Digite a resposta para a pergunta",
    SessionTimeoutAutomaticLogoutSettings:"Tempo limite da sessão: Configurações de logout automático",
   Thesystemwillautomatically:"O sistema desconectará você automaticamente após um período de inatividade. O tempo limite padrão é de 5 minutos, mas você pode ajustar essa duração conforme necessário."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Número Total de Empresas Pesquisadas",
    TotalNumberofCompaniesCollected:"Número Total de Empresas Coletadas",
    TotalNumberofUpdateReportsOrdered:"Número Total de Relatórios de Atualização Solicitados",
    Date:"Data",
    UserName:"Nome de Usuário",
    CompanyName:"Nome da Empresa",
    Status:"Status",
    UsageType:"Tipo de Uso",
    Entercompanyname:"Digite o nome da empresa",
    Download:"Baixar"
},
OrganizationalManagement:{
    GroupName:"Nome do Grupo",
    ParentGroupName:"Nome do Grupo Principal",
    Organization:"Organização",
    GroupID:"ID do Grupo",
    GroupStatus:"Status do Grupo",
    Operation:"Operação",
    NewlyBuilt:"Recém-criado",
    UserAccount:"Conta de Usuário",
    Role:"Função",
    AccountStatus:"Status da Conta",
    RoleName:"Nome da Função",
    Position:"Cargo",
    RoleStatus:"Status da Função",
    Valid:"Válido",
    Invalid:"Inválido",
    PermissionSettings:"Configurações de Permissão"
},
BillingandPayment:{
    TotalNumberofOrders:"Número Total de Pedidos",
    TotalPaymentAmount:"Valor Total do Pagamento",
    TotalDeductionCredits:"Créditos Totais de Dedução",
    Date:"Data",
    UserAccount:"Conta do Usuário",
    CompanyName:"Nome da Empresa",
    OrderNo:"Nº do Pedido",
    OrderType:"Tipo de Pedido",
    OrderStatus:"Status do Pedido",
    Download:"Download",
    PaymentAmount:"Valor do Pagamento",
    Contactus:"Fale Conosco",
    DownloadInvoice:"Baixar Fatura",
    CreditsDeducted:"Créditos Deduzidos",
    ReportOrderStatus:"Relatar Status do Pedido",
    CompanyID:"ID da Empresa",
    CountryRegion:"País/Região",
    AddressLine:"Endereço",
    City:"Cidade",
    ZipCode:"CEP",
    FirstName:"Nome",
    LastName:"Sobrenome",
    PhoneNumber:"Número de Telefone",
    Email:"E-mail",
    BankAccountHolderName:"Nome do Titular da Conta Bancária",
    BeneficiaryBankName:"Nome do Banco Beneficiário",
    SWIFTCODE:"CÓDIGO SWIFT",
    AccountNumber:"Número da Conta",
    BeneficiaryBankAddress:"Endereço do Banco Beneficiário",
    ABA:"ABA (Número de Roteamento)",
    IBANnumber:"Número IBAN"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...ptLocale
}

export default pt